import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './enhanced'
import '@/assets/css/common.css'
import '@/assets/font/iconfont/iconfont.css'
import './elementui'
import './perfect-scrollbar'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
